import { DashboardLayout } from "layouts/dashboard.layout";
import { SalesChart } from "./components/SalesChart.component";

export function IPFReportsPage() {
  return (
    <DashboardLayout>
      <SalesChart />
    </DashboardLayout>
  );
}
